"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _4d_mapper_1 = require("4d-mapper");
const vasat_1 = require("vasat");
const main_service_1 = require("../main/main.service");
const acl_service_1 = require("./acl/acl.service");
/**
All the crap needed for treeview

*/
/** Flat node with expandable and level information */
class DynamicFlatNode {
    constructor(item, level = 1, expandable = false, isLoading = false) {
        this.item = item;
        this.level = level;
        this.expandable = expandable;
        this.isLoading = isLoading;
    }
}
exports.DynamicFlatNode = DynamicFlatNode;
/**
 * Database for dynamic data. When expanding a node in the tree, the data source will need to fetch
 * the descendants data from the database.
 */
class DynamicDatabase {
    constructor(fourD, mainService, permissions) {
        this.fourD = fourD;
        this.mainService = mainService;
        this.permissions = permissions;
        this.rootLevelNodes = [];
    }
    /** Initial data from database */
    initialData(search) {
        this.searchQuery = search;
        var vv = this.fourD.teams.filter(t => t != this.fourD.activeTeam);
        var base = [
            ['folder', 'myFiles']
        ];
        /*
            if(vv.length)
              base.push(
                ['share-alt','shared']
              )
        */
        if (this.fourD.sampleAccount && this.permissions.can.see_samples && this.permissions.can.see_samples.site_settings)
            base.push(['landmark', 'sample']);
        /* base.push(['google-drive','google-drive']);
          base.push(['dropbox','dropbox']);*/
        return rxjs_1.Observable.of(base.map(b => {
            var fake = new _4d_mapper_1.Folder(this.fourD.V);
            fake['root'] = b[1];
            fake['icon'] = b[0];
            if (b[1] == 'myFiles')
                fake.account = this.fourD.activeTeam;
            return new DynamicFlatNode(fake, 0, true);
        })); /*
        var searchQ = this.fourD.V.searchByObject(Folder)
        if(search && search.length)
          searchQ.contains('name',search)
        else
          searchQ.isNull('parent')
    
        if(this.baseQuery){
          Object.keys(this.baseQuery).forEach(k => searchQ.equals(k,this.baseQuery[k]))
        }
        return searchQ.limit(50)
            .sortBy('name')
            .queryObservable().pipe(
              map(res => res.items.map(i => new DynamicFlatNode(i, 0, true)))
        )*/
    }
    getChildren(node) {
        var objs;
        if (node.item['root'] == 'myFiles') {
            if (this.searchQuery) {
                objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', 'null').useCache(true).equals('account', this.fourD.activeTeam.id).contains('name', this.searchQuery).sortBy('dateUpdated', true).limit(10000).queryObservable();
            }
            else {
                objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', 'null').useCache(true).equals('account', this.fourD.activeTeam.id).sortBy('dateUpdated', true).limit(10000).queryObservable();
            }
        }
        else if (node.item['root'] == 'shared') {
            var id = "";
            this.fourD.teams.filter(t => t != this.fourD.activeTeam).forEach((a) => id += "|" + a.id);
            if (id.length)
                id = id.substring(1);
            objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).complexQuery({
                col: 'account', op: 'in', ids: [this.fourD.activeTeam.id, this.fourD.sampleAccount.id], not: true
            }).queryObservable();
        }
        else if (node.item['root'] == 'sample') {
            objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', 'null').equals('account', this.fourD.sampleAccount.id).queryObservable();
        }
        else if (node.item['root'] == 'google-drive') {
            objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', this.mainService.googleFolder).equals('account', this.fourD.activeTeam.id).queryObservable();
        }
        else if (node.item['root'] == 'dropbox') {
            objs = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', this.mainService.dropboxFolder).equals('account', this.fourD.activeTeam.id).queryObservable();
        }
        else {
            var searchQ = this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('parent', node.item);
            if (this.baseQuery) {
                Object.keys(this.baseQuery).forEach(k => searchQ.equals(k, this.baseQuery[k]));
            }
            objs = searchQ.limit(50).sortBy('dateUpdated', true).queryObservable();
        }
        return objs.pipe(operators_1.map(res => {
            node.expandable = !!res.items.length;
            return res.items.filter(a => (this.permissions.can.see_public_data && this.permissions.can.see_public_data.site_settings) ||
                a.uid != 'public_global').map(i => new DynamicFlatNode(i, node.level + 1, true));
        }));
    }
    isExpandable(node) {
        return true;
    }
}
exports.DynamicDatabase = DynamicDatabase;
/**
 * File database, it can build a tree structured Json object from string.
 * Each node in Json object represents a file or a directory. For a file, it has filename and type.
 * For a directory, it has filename and children (a list of files or directories).
 * The input will be a json object string, and the output is a list of `FileNode` with nested
 * structure.
 */
class DynamicDataSource {
    /*
    get data(): DynamicFlatNode[] { return this.dataChange.value; }
    set data(value: DynamicFlatNode[]) {
      this.treeControl.dataNodes = value;
      this.dataChange.next(value);
    }*/
    constructor(treeControl, database) {
        this.treeControl = treeControl;
        this.database = database;
        this.dataChange = new rxjs_1.BehaviorSubject([]);
        this.filesChange = new rxjs_1.Subject();
        this.data = this.dataChange.value;
    }
    connect(collectionViewer) {
        this.treeControl.expansionModel.changed.subscribe(change => {
            if (change.added ||
                change.removed) {
                this.handleTreeControl(change);
            }
        });
        return rxjs_1.merge(collectionViewer.viewChange, this.dataChange).pipe(operators_1.map(() => this.data));
    }
    /** Handle expand/collapse behaviors */
    handleTreeControl(change) {
        if (change.added) {
            change.added.forEach(node => this.toggleNode(node, true));
        }
        if (change.removed) {
            change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
        }
    }
    /**
     * Toggle the node, remove from display list
     */
    toggleNode(node, expand) {
        this.database.getChildren(node).subscribe(s => {
            const index = this.data.indexOf(node);
            if (expand) {
                const nodes = s;
                this.data.splice(index + 1, 0, ...nodes);
            }
            else {
                let count = 0;
                for (let i = index + 1; i < this.data.length
                    && this.data[i].level > node.level; i++, count++) { }
                this.data.splice(index + 1, count);
            }
            this.filesChange.next(this.database.fourD.V.searchByObject(_4d_mapper_1.Dataset).sortBy('name')
                .equals('folder', node.item.id));
            // notify the change
            this.dataChange.next(this.data);
            node.isLoading = false;
        });
        node.isLoading = true;
    }
}
exports.DynamicDataSource = DynamicDataSource;
